export default __webpack_public_path__ + "static/media/tutorial5-3.350d4f20.png";